import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> { }

const Edit: React.FC<Props> = (props) => {
    return (
        <svg {...props} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Edit 2">
                <path id="Rectangle 74" d="M13 7.66797V10.3346C13 12.1756 11.5076 13.668 9.66667 13.668H4.33333C2.49239 13.668 1 12.1756 1 10.3346V5.0013C1 3.16035 2.49238 1.66797 4.33333 1.66797H7" stroke="#0288D1" strokeLinecap="round" />
                <path id="Rectangle 74_2" d="M10.4485 1.19157C10.9688 0.670476 11.8127 0.670157 12.3334 1.19086L13.3263 2.18369C13.8425 2.69995 13.8479 3.53571 13.3383 4.05856L8.63165 8.88761C8.25536 9.27368 7.73928 9.49137 7.20038 9.49135L6.06891 9.4913C5.50035 9.49127 5.0463 9.01733 5.07021 8.44885L5.11961 7.27449C5.14068 6.77367 5.34883 6.299 5.70287 5.94442L10.4485 1.19157Z" stroke="#0288D1" />
            </g>
        </svg>
    );
};

export default Edit;
